import { render, staticRenderFns } from "./AddPart.vue?vue&type=template&id=1f636c66&"
import script from "./AddPart.vue?vue&type=script&lang=js&"
export * from "./AddPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports